/**
 * 配置
 */
const systemArea = 'zzd'

const env = require(`./area/${systemArea}`)

module.exports = env
